export class AddressResponseModel {
  id: number = 0;
  line1: string | null = null;
  line2: string | null = null;
  city: string | null = null;
  zipCode: string | null = null;
  stateName: string | null = null;
  countryName: string | null = null;
  latitude: number | null = null;
  longitude: number | null = null;
  type: number | null = null;

  constructor(init?: Partial<AddressResponseModel>) {
    Object.assign(this, init);
  }
}